export type ClassValue = string | number | false | null | undefined;

/**
 * Une clases descartando falsy. Sustituye a `clsx`/`classnames`: una linea no
 * justifica una dependencia.
 */
export function cx(...values: ClassValue[]): string {
  return values.filter((v): v is string | number => Boolean(v)).join(' ');
}
